import { UseRecordsOptions } from "../../api/useRecords";

export const eegDataOptions = {
    fieldsToRemove: {
        fieldTypesToRemove: ["alias"],
    },
    groupsOptions: {
        fieldsWithExtraOptions: [],
    },
} as UseRecordsOptions;
